<template>
	<section>
		<div class="header-wrapper">
			<div class="header-left-wrapper">
				<div v-if="userInfo.photo" class="profile-user-wrapper">
					<img src="../../../../assets/img/feelings2/sweat.svg" class="mood-bubble" v-if="this.selectedFeeling === '1' && !this.showMood">
					<img src="../../../../assets/img/feelings2/slightly_frowning_face.svg" class="mood-bubble" v-if="this.selectedFeeling === '2' && !this.showMood">
					<img src="../../../../assets/img/feelings2/neutral_face.svg" class="mood-bubble" v-if="this.selectedFeeling === '3' && !this.showMood">
					<img src="../../../../assets/img/feelings2/blush.svg" class="mood-bubble" v-if="this.selectedFeeling === '4' && !this.showMood">
					<img src="../../../../assets/img/feelings2/smile.svg" class="mood-bubble" v-if="this.selectedFeeling === '5' && !this.showMood">
					<img :src="userInfo.photo" class="profile-img" @click="redirectTo('perfil')"/>
				</div>

				<div v-else class="profile-user-wrapper">
					<img src="../../../../assets/img/feelings2/sweat.svg" class="mood-bubble" v-if="this.selectedFeeling === '1' && !this.showMood">
					<img src="../../../../assets/img/feelings2/slightly_frowning_face.svg" class="mood-bubble" v-if="this.selectedFeeling === '2' && !this.showMood">
					<img src="../../../../assets/img/feelings2/neutral_face.svg" class="mood-bubble" v-if="this.selectedFeeling === '3' && !this.showMood">
					<img src="../../../../assets/img/feelings2/blush.svg" class="mood-bubble" v-if="this.selectedFeeling === '4' && !this.showMood">
					<img src="../../../../assets/img/feelings2/smile.svg" class="mood-bubble" v-if="this.selectedFeeling === '5' && !this.showMood">
					<div class="profile-img" @click="redirectTo('perfil')">
						{{ getNameInitials(userInfo.name) }}
					</div>
				</div>
				<div class="header">
					<div class="text-name">
							{{ userInfo.name }}
					</div>
					<div class="text-job-position">
							{{ userInfo.office }}
					</div>
				</div>
			</div>

			<div class="header-right-wrapper">
			<form class="header-middle-wrapper" @submit.prevent="sendFeeling()" v-if="showMood">
			<dot-loader v-if="isLoading" id="header-loader"></dot-loader>
				<div class="first-line-header-middle-wrapper">
					{{$t("Como você está se sentindo?")}}

				<general-tooltip :content="'Fique Tranquilo, essa informação só será visualizada pelo seu gestor!'" @show-tooltip="handleTooltip">
					<img
						src="../../../../assets/img/tooltip/information-circle-outline.svg"
						alt="dica de ferramenta"
						@mouseover="showTooltip"
						@mouseout="hideTooltip"
					>
				</general-tooltip>

				<div class="feelings-wrapper">
					<img src="../../../../assets/img/feelings2/sweat.svg"
						@click="handleFeelingClick('1')"
						:class="[{'feeling-img-active': this.selectedFeeling === '1'}, 'feeling-img']"
					>
					<img src="../../../../assets/img/feelings2/slightly_frowning_face.svg"
						@click="handleFeelingClick('2')"
						:class="[{'feeling-img-active': this.selectedFeeling === '2'}, 'feeling-img']"
					>
					<img src="../../../../assets/img/feelings2/neutral_face.svg"
						@click="handleFeelingClick('3')"
						:class="[{'feeling-img-active': this.selectedFeeling === '3'}, 'feeling-img']"
					>
					<img
						src="../../../../assets/img/feelings2/blush.svg"
						@click="handleFeelingClick('4')"
						:class="[{'feeling-img-active': this.selectedFeeling === '4'}, 'feeling-img']"
						>
					<img
						src="../../../../assets/img/feelings2/smile.svg"
						@click="handleFeelingClick('5')"
						:class="[{'feeling-img-active': this.selectedFeeling === '5'}, 'feeling-img']"
					>
					</div>
				</div>

				<div class="second-line-header-middle-wrapper">
					<div class="feeling-content-hidden">
						<div class="text-area-wrapper" v-if="!isLoading">
							<div class="text-area-clone">
								<textarea
									:placeholder="$t('Nos conte porque você está se sentindo assim...')"
									v-model="sendCommentBody.comment"
									@input="handleInput"
									ref="textarea"
									maxlength="120"
								>
								</textarea>
								<div class="follower" v-if="sendCommentBody.comment.length > 0">
									- {{ this.followerText }}
								</div>
								<button class="send-feeling-button" type="submit">{{$t("Enviar")}}</button>
							</div>
						</div>

					</div>
				</div>
			</form>

        <div class="svg-wrapper">
          <svg v-if="notificationReminder" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" class="notification-point">
            <circle cx="3" cy="3" r="3" fill="#FF445D"/>
          </svg>
          <ion-icon name="document-text-outline" @click="redirectToV2Function('pt', 'lembretes')"/>
        </div>

				<div class="svg-wrapper">
					<svg v-if="showChat.hasNotification" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" class="notification-point">
						<circle cx="3" cy="3" r="3" fill="#FF445D"/>
					</svg>
					<svg
					xmlns="http://www.w3.org/2000/svg"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					alt="icone-chat"
					class="chatbubbles"
					@click="redirectChat()"
					v-if="showChat.show"
					>
						<path d="M23.5703 17.5328C23.5156 17.3359 23.6359 17.0625 23.7507 16.8656C23.7858 16.807 23.8242 16.7504 23.8656 16.6961C24.8479 15.2364 25.3734 13.5173 25.375 11.7578C25.3914 6.71562 21.1367 2.625 15.8757 2.625C11.2875 2.625 7.45933 5.74766 6.56245 9.89297C6.42828 10.5074 6.36044 11.1344 6.36011 11.7633C6.36011 16.8109 10.4507 21.0109 15.7117 21.0109C16.5484 21.0109 17.675 20.7594 18.2929 20.5898C18.9109 20.4203 19.5234 20.1961 19.682 20.1359C19.8446 20.0746 20.0168 20.0431 20.1906 20.043C20.3801 20.0422 20.5679 20.0794 20.7429 20.1523L23.8437 21.2516C23.9117 21.2803 23.9836 21.2988 24.057 21.3062C24.173 21.3062 24.2843 21.2602 24.3663 21.1781C24.4484 21.0961 24.4945 20.9848 24.4945 20.8687C24.4907 20.8187 24.4815 20.7692 24.4671 20.7211L23.5703 17.5328Z" stroke="#7E8DA7" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
						<path d="M3.63456 12.6875C2.9173 13.9761 2.57033 15.4379 2.632 16.9113C2.69367 18.3848 3.16158 19.8125 3.98402 21.0366C4.11035 21.2275 4.18144 21.3752 4.15956 21.4741C4.13769 21.5731 3.50714 24.8577 3.50714 24.8577C3.49198 24.9345 3.49773 25.014 3.5238 25.0879C3.54987 25.1618 3.5953 25.2273 3.65535 25.2777C3.73547 25.3415 3.83509 25.3759 3.93753 25.375C3.99227 25.3752 4.04646 25.364 4.09667 25.3422L7.17066 24.1391C7.38222 24.0557 7.61824 24.0596 7.82691 24.15C8.86269 24.5536 10.0078 24.8063 11.1535 24.8063C12.691 24.8079 14.2014 24.4024 15.5313 23.631" stroke="#7E8DA7" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
					</svg>
				</div>

				<div class="svg-wrapper" @click="openNoticesModal()">
					<div class="opacity-background" />


					<svg v-if="hasNotification" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" class="notification-point">
						<circle cx="3" cy="3" r="3" fill="#FF445D"/>
					</svg>
					<svg
					mlns="http://www.w3.org/2000/svg"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					alt="icone-chat"
					class="notifications"
				>
					<path d="M17.5 21V21.875C17.5 22.8033 17.1313 23.6935 16.4749 24.3499C15.8185 25.0063 14.9283 25.375 14 25.375C13.0718 25.375 12.1815 25.0063 11.5252 24.3499C10.8688 23.6935 10.5 22.8033 10.5 21.875V21M23.3888 19.2188C21.9844 17.5 20.9929 16.625 20.9929 11.8863C20.9929 7.54688 18.777 6.00086 16.9532 5.25C16.7109 5.15047 16.4828 4.92187 16.409 4.67305C16.0891 3.58422 15.1922 2.625 14 2.625C12.8078 2.625 11.9104 3.58477 11.5938 4.67414C11.5199 4.9257 11.2919 5.15047 11.0496 5.25C9.22362 6.00195 7.00987 7.5425 7.00987 11.8863C7.00714 16.625 6.01565 17.5 4.61128 19.2188C4.0294 19.9309 4.53909 21 5.55682 21H22.4487C23.461 21 23.9674 19.9276 23.3888 19.2188Z"
						stroke="#7E8DA7"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
					</svg>
					<div class="notifications-wrapper">
						<div class="loader-wrapper">
							<dot-loader v-if="noticesLoader" class="notices-loader"></dot-loader>
						</div>
						<div class="svg-arrow" />
						<div class="text-wrapper" v-if="!noticesLoader">
							<div v-for="notice in notices" :key="notice.id" class="notice-text">
								{{ notice.text }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import generalTooltip from '../generalTooltip.vue';
import gsap, { Power1, Bounce } from 'gsap';
import { REQUEST_SERVICE } from '../../../../requestConfig';
import {
	SEND_USER_FEELING,
	HOME_NOTIFICATIONS
} from '../../../../urlConfig';
import { UTIL_SERVICE } from '../../../../utils';
import DotLoader from '../dotLoader.vue';
import shadowBox from './shadowBox.vue';

  export default {
		components: { generalTooltip, DotLoader, shadowBox },
		name: 'newHeader',
		data() {
			return {
				hasNotification: false,
				notices: [],
				noticesLoader: false,
				isNoticesOpened: false,
				isFeelingSent: false,
				isTooltipVisible: false,
				isFeelingsAreaActive: false,
				selectedFeeling: 0,
				isHiddenContentActive: false,
				sendCommentBody: {
					comment: '',
				},
				showTextFeelings: false,
				textFeelings: {
					'5': this.$t("Se sentindo muito feliz 😆"),
					'4': this.$t("Se sentindo feliz 🙂"),
					'3': this.$t("Se sentindo neutro 😐"),
					'2': this.$t("Se sentindo triste 🙁"),
					'1': this.$t("Se sentindo muito triste 😓")
				},
				followerText: '',
				highlightLeft: 0,
				highlightTop: 7,
				selectedFeeling: '',
				isLoading: false,
				showChat: false,
			}
		},
		props: {
			userInfo:{
				type: Object,
				default() {
					return {
						name: '',
						photo: '',
						officeName: ''
					}
				}
			},
			showMood: {
				type: Boolean,
				required: true,
			},
      notificationReminder: {
        type: Boolean,
        required: false,
      }
		},
		methods: {
      redirectToV2Function(language, page) {
        UTIL_SERVICE.checkLocationAndRedirectToV2(language, page);
      },
			redirectTo(route) {
        if(!route) {
          this.$router.push('/')
        } else {
          this.$router.push(`/${route}`)
        }
      },
			getNotifications() {
				this.noticesLoader = true;
				REQUEST_SERVICE.get(HOME_NOTIFICATIONS).then((response) => {
					UTIL_SERVICE.console('RESULT HOME_NOTIFICATIONS', response.data)

					this.notices = response.data;
					this.noticesLoader = false;
				})
      },
			getNameInitials (name) {
				const parts = name.split(' ');
				const initials = parts.reduce((acc, part, index) => {
					if (index === 0 || index === parts.length - 1) {
						if (part.match(/^[A-Za-z]+$/)) {
							acc.push(part.charAt(0).toUpperCase());
						}
					}
					return acc;
				}, []);
				return initials.join('');
			},
			showTooltip() {
				this.isTooltipVisible = true;
			},
			hideTooltip() {
				this.isTooltipVisible = false;
			},
			handleTooltip(isVisible) {
				this.isTooltipVisible = isVisible;
			},
			handleFeelingAreaClick() {
				if(this.isFeelingsAreaActive) {
					gsap.to('.header-middle-wrapper', {
						height: '174px',duration: 0.3, ease: Power1.easeOut, boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.10), 0px 6px 14px 0px rgba(0, 0, 0, 0.10), 0px 26px 26px 0px rgba(0, 0, 0, 0.09), 0px 58px 35px 0px rgba(0, 0, 0, 0.05), 0px 103px 41px 0px rgba(0, 0, 0, 0.01), 0px 161px 45px 0px rgba(0, 0, 0, 0.00)',
					})

					gsap.to('.second-line-header-middle-wrapper',
						{ opacity: 1, duration: 0.3, display: 'block',
						ease: Power1.easeIn }
					)

					gsap.to('.send-feeling-button', {
						 pointerEvents: 'auto'
					})
				}
			},
			handleFeelingClick(selectedFeeling) {
				this.selectedFeeling = selectedFeeling
				this.handleTextfeeling(selectedFeeling)
				this.isFeelingsAreaActive = true;
				this.handleFeelingAreaClick();
			},
			validateComment() {
				if(this.sendCommentBody.comment.length > 0) {
					this.showTextFeelings = true
				} else {
					return false;
				}
			},
			handleTextfeeling(feeling) {
				Object.keys(this.textFeelings).filter((e) => {
					if(e === feeling) {
						this.followerText = this.textFeelings[feeling]
					}
				})
			},
			handleInput() {
				const textarea = this.$refs.textarea;
				const cursorPosition = textarea.selectionStart;
				const lines = this.sendCommentBody.comment.split("\n");

				let totalWidth = 0;
				let lineIndex = 0;
				for (let i = 0; i < lines.length; i++) {
					if (totalWidth + lines[i].length >= cursorPosition) {
						lineIndex = i;
						break;
					}
					totalWidth += lines[i].length + 1; // Add 1 for line break
				}

				const lineBreaksBeforeCursor = lineIndex;

				const line = lines[lineIndex];
				const textWidth = this.measureTextWidth(line);
				const lineHeight = this.measureLineHeight();

				const maxCharWidth = this.measureCharWidth();
				const maxWidthInChars = 37;

				if (textWidth > maxCharWidth * maxWidthInChars) {
					totalWidth = totalWidth - (line.length + 1); // Subtract the current line's length
				} else {
					this.highlightLeft = Math.min(
						textWidth,
						maxCharWidth * Math.min(line.length, maxWidthInChars)
					);
				}

				this.highlightTop = lineBreaksBeforeCursor * lineHeight + 7; // Adjust for padding
    	},
			measureTextWidth(text) {
				const span = document.createElement("span");
				span.style.visibility = "hidden";
				span.style.position = "absolute";
				span.style.whiteSpace = "nowrap";
				span.innerText = text;
				document.body.appendChild(span);
				const width = span.offsetWidth;
				document.body.removeChild(span);
				return width;
			},
			measureLineHeight() {
				const span = document.createElement("span");
				span.innerText = "teste"; // You can adjust the text to match your font size
				document.body.appendChild(span);
				const height = span.offsetHeight;
				document.body.removeChild(span);
				return height;
			},
			measureCharWidth() {
				const span = document.createElement("span");
				span.innerText = "A"; // You can adjust the character to match your font size
				document.body.appendChild(span);
				const width = span.offsetWidth;
				document.body.removeChild(span);
				return width;
    	},
			sendFeeling() {
				const sendFeelingBody = {
					mood: Number(this.selectedFeeling),
					comment: this.sendCommentBody.comment
				}

				if(!this.isFeelingSent) {
					this.isLoading = true;
					this.isFeelingSent = true;
					REQUEST_SERVICE.post(SEND_USER_FEELING, sendFeelingBody).then((response) => {
						UTIL_SERVICE.console("RESULT SEND FEELING: ", response.data);

						this.$toast.success(this.$t("Sentimento enviado."), {
							timeout: 3000,
							closeOnClick: false,
							pauseOnFocusLoss: false,
							pauseOnHover: false,
							closeButton: 'button',
						});

						localStorage.setItem('selectedFeeling', JSON.stringify(this.selectedFeeling));
						this.showMood = false;
						this.isLoading = false;
					}).catch((reason) => {
						UTIL_SERVICE.console("SEND FEELING ERROR:", reason);
					})
				}
			},
			redirectChat() {
				this.$router.push('/conversas')
			},
			checkSelectedFeeling() {
				const selectedFeeling = JSON.parse(localStorage.getItem('selectedFeeling'));
				if(selectedFeeling) {
					this.selectedFeeling = selectedFeeling
				}
			},
			openNoticesModal() {
				this.isNoticesOpened = !this.isNoticesOpened;
				this.hasNotification = false;
				this.getNotifications();

				if(this.isNoticesOpened) {
					gsap.to('.opacity-background', {
						background: 'var(--opacityBackground)', visibility: 'visible', duration: 0.3
					})
					gsap.to('.notifications-wrapper', {
						display: 'block', visibility: 'visible', x: -20, ease: 'elastic.out(1, 0.3)', duration: 1
					})
				} else {
					gsap.to('.notifications-wrapper', {
						x: 20, visibility: 'hidden', duration: 0.3
					})
					gsap.to('.opacity-background', {
						duration: 0.3,  visibility: 'hidden',
					})
				}
			},
		},
		beforeMount() {
			this.checkSelectedFeeling()
		},
		mounted() {
			const showChat = JSON.parse(localStorage.getItem('showChat'));
			if(showChat) {
				this.showChat = showChat
			}
			const hasNotification = JSON.parse(localStorage.getItem('hasNotification'));
			if(hasNotification) {
				this.hasNotification = hasNotification
			}
		}
}
</script>

<style scoped lang="scss">
    .header-wrapper {
        display: flex;
        justify-content: space-between;
        margin-right: 50px;
        .header-left-wrapper {
					display: flex;
					gap: 15px;

					.profile-user-wrapper {
						cursor: pointer;
						position: relative;
						.mood-bubble {
							height: 29px;
							width: 29px;
							object-fit: cover;
							position: absolute;
							left: 40px;
							top: -6px;
						}
					}


            .text-name {
							transition: 0.5s;
							color: var(--blueText);
							font-weight: 600;
							font-size: 23px;
            }

            .text-job-position {
							transition: 0.5s;
							color: var(--blueText);
							font-weight: 400;
							font-size: 18px;
            }

            .profile-img {
							transition: 0.5s;
							object-fit: cover;
							display: flex;
							align-items: center;
							justify-content: center;
							width: 68px;
							height: 68px;
							border-radius: 68px;
							border: 4px solid var(--border);
							background: #d9d9d9;
							color: #FFF;
							font-size: 15.875px;
							font-weight: 500;
							box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.10);

							img {
								object-fit: cover;
								display: flex;
								align-items: center;
								justify-content: center;
								width: 68px;
								height: 68px;
								border-radius: 68px;
								border: 4px solid #fff;
								background: #d9d9d9;
								color: #FFF;
								font-size: 15.875px;
								font-weight: 500;
								box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.10);
							}
            }
        }

        .header-right-wrapper{
						display: flex;
						align-items: flex-start;
            padding: 1px;
						gap: 16px;

					.header-middle-wrapper {
						transition: 0.5s;
						display: flex;
						align-items: center;
						justify-content: flex-start;
						border-radius: 20px;
						border: 1px solid var(--border);
						background: var(--leftMenuColor);
						width: 580px;
						height: 53px;
						flex-shrink: 0;
						font-weight: 600;
						font-size: 16px;
						color: var(--grayText);
						padding: 14px 0px 14px 19px;
						position: relative;
						z-index: 0;

					#header-loader {
						position: absolute;
						margin: 0 !important;
						left: 30% !important;
						top: 50% !important;
					}

					.first-line-header-middle-wrapper {
						display: flex;
						align-items: center;
						justify-content: flex-start;
						width: 100%;
						position: absolute;
						top: 15px;

						.header-tooltip {
							margin-left: 10px;
						}

						.feelings-wrapper {
							width: 41%;
							display: flex;
							gap: 10px;
							justify-content: space-evenly;
							position: absolute;
							right: 20px;
							margin-right: 2%;

							img {
								cursor: pointer;
							}

							.feeling-img {
								opacity: 0.6;
								transition: transform 0.3s ease;
							}

							.feeling-img:hover {
								opacity: 1;
								transform: scale(1.2)

							}

							.feeling-img-active {
								opacity: 1;
							}

          	}
					}

					.second-line-header-middle-wrapper {
						opacity: 0;
						max-height: auto;
						width: 97%;
						position: absolute;
						top: 70px;

						.feeling-content-hidden {
							width: 98%;
							height: auto;
							position: relative;

							.text-area-wrapper {
								box-sizing: border-box;
								position: relative;

								.text-area-clone {
									transition: 0.5s;
									padding: 0;
									text-align: left;
									border-radius: 0;
									min-height: 60px;
									max-width: 99%;
									background: var(--bodyColor2) !important;
									resize: none;
									color: #3A424E !important;
									font-size: 14px;
									font-style: normal;
									font-weight: 400;
									overflow: hidden;
									word-wrap: break-word;
									border: 1px solid var(--border);
									border-radius: 10px !important;

									textarea {
										transition: 0.5s;
										padding: 0;
										text-align: left;
										border-radius: 0;
										min-height: 60px;
										max-width: 60%;
										resize: none;
										color: var(--text) !important;
										background: var(--bodyColor2);
										font-size: 14px;
										font-style: normal;
										font-weight: 400;
										padding: 5px 0px 0px 10px;
										overflow: hidden;
										word-wrap: break-word;
										white-space: pre-wrap;
										box-sizing: border-box;
									}

									textarea::placeholder {
										font-size: 14px;
										font-style: normal;
										font-weight: 400;
										color: var(--text);
									}

									.follower {
										position: absolute;
										top: 45px;
										right: 21px;
										color: #7E8DA7;
										font-weight: 400;
										font-size: 14px;
										transition: top 0.1s ease-in-out, left 0.1s ease-in-out;
										margin-left: 24px;
									}
								}
							}
							.send-feeling-button {
								pointer-events: none;
								display: flex;
								width: 117px;
								padding: 4px 16px;
								font-size: 14px;
								font-style: normal;
								font-weight: 600;
								justify-content: center;
								align-items: center;
								background: var(--darkBlue);
								color: #fff;
								border-radius: 20px;
								border: 1px solid var(--darkBlue);
								height: 25px;
								position: absolute;
								right: 20px;
								bottom: -30px;
							}
						}
					}
        }

						.svg-wrapper {
							position: relative;

              ion-icon {
                font-size: 28px;
                color: #7E8DA7;
                cursor: pointer;
              }

              ion-icon:hover {
                color: #333;
              }

							.opacity-background {
								height: 100%;
								width: 100%;
								left: 0;
								top: 0;
								overflow: hidden;
								position: fixed;
    						z-index: 5;
								visibility: hidden;
							}

							.notification-point {
								width: 8px;
								height: 8px;
								position: absolute;
								right: -6px;
								top: -1px
							}

							.notifications-wrapper {
								position: absolute;
								height: 450px;
								min-height: fit-content;
								width: 350px;
								left: -279px;
								top: 46px;
								z-index: 10;
								/* border: 1px solid; */
								border-radius: 20px !important;
								background: var(--bodyColor2);
								border: 1px solid var(--border) !important;
								padding: 20px;
								visibility: hidden;

								.loader-wrapper {
									position: relative;

									.notices-loader {
										right: 0;
										left: 0;
										top: 0;
										margin-top: 60%;
										margin-right: 80%;
									}
								}

								.svg-arrow {
									content: "";
									position: absolute;
									height: 0;
									width: 0;
									border: 10px solid transparent;
									border-bottom: 10px solid var(--bodyColor2);
									right: 26px;
									top: -20px;
								}
								.text-wrapper {
									overflow: auto;
									min-height: fit-content;
									width: 314px;
									height: 100%;
									padding-right: 20px;
									.notice-text {
										padding: 20px;
										color: var(--text);
										font-size: 12px;
										line-height: 18px;
										border-bottom: 1px solid var(--border);
										border-bottom-width: 90%;
										min-height: 30px;
										display: flex;
										align-items: center;
									}

									.notice-text:last-child {
										border-bottom: none;
									}

								}
								.text-wrapper::-webkit-scrollbar {
									width: 4px;
									height: 4px;
									background-color: #F5F5F5;
								}

								.text-wrapper::-webkit-scrollbar-thumb {
									background-color: #9c9797;
									border: 0 solid #9c9797;
									height: 4px;
								}

								.text-wrapper::-webkit-scrollbar-track {
									-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
									background-color: #F5F5F5;
								}
							}
						}
						.notifications {
							cursor: pointer;
						}
						.notifications:hover path {
							stroke: var(--activeHoverSidebar) !important;
						}

						.notifications:active path {
							stroke: #fff;
						}

						.chatbubbles {
							cursor: pointer;
						}
						.chatbubbles:hover path {
							stroke: var(--activeHoverSidebar) !important;
						}

						.chatbubbles:active path {
							stroke: #fff;
						}
        }
    }
</style>



// WEBPACK FOOTER //
// src/vue/views/components/layouts/newHeader.vue